import useUserStore from 'store/user.store';
import { NonAdminView } from './NonAdminView/NonAdminView';
import { checkUserPermission } from '@common/auth';
import { AdminView } from './AdminView';

//Here we will hold the logic that renders either admin or non admin view
export const Dashboard = () => {
  const { user } = useUserStore();
  const isAdmin = checkUserPermission(user, 'view_admin_dashboard');

  return isAdmin ? <AdminView /> : <NonAdminView />;
};
